import { Component, OnInit } from '@angular/core';
import { WorkflowProcessService } from '../workflow-process.service';
import { HierarchyTab } from '@ov-suite/ui';
import { ActivatedRoute } from '@angular/router';
import { WorkflowProcess } from '@ov-suite/models-shared';

@Component({
  selector: 'ov-suite-workflow-process-list',
  templateUrl: './workflow-process-list.component.html',
  styleUrls: ['./workflow-process-list.component.scss'],
})
export class WorkflowProcessListComponent implements OnInit {
  // Class - Required
  formClass = WorkflowProcess;

  filter: Record<string, string[]>;

  tabs: HierarchyTab[] = [
    { title: 'Workflow Processes', iconClass: '', path: '/workflow-processes' },
  ];

  constructor(
    private readonly route: ActivatedRoute,
    public readonly workflowProcessService: WorkflowProcessService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(param => {
      const id = param['id'];
      if (id) {
        this.filter = { processDefinitionKey: param['id'] };
      }
    });
  }
}
